import { Fragment, useState, useEffect } from 'react';
import '../styles.scss';
import { SettingOutlined } from '@ant-design/icons';
import MegaTable from '../../../components/MagaTableV2';
import { mixGetV2 } from '../../../services/mixin'

const TabTableDetail = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.complaint_history_detail?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheSupportHistoryDetail',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // { headerName: 'Số khung (VIN)', field: 'chassis_no' },
      // { headerName: 'Biển số xe', field: 'number_plate' },
      // { headerName: 'Số máy', field: 'engine_no' },
      // { headerName: 'Số Km hiện tại', field: 'present_mile_age' },
      // { headerName: 'Ngày giao xe', field: 'Ngày giao xe' },
      // { headerName: 'Phân loại cấp 1', field: 'doc_status0' },
      // { headerName: 'Phân loại cấp 2', field: 'doc_status1' },
      // { headerName: 'Nội dung ', field: 'complain_desc' },
      // { headerName: 'Giải pháp đại lý', field: 'solution' },
      // { headerName: 'Nhân viên', field: 'employee_name' },
      // { headerName: 'Tình trạng hiện tại lần 1', field: 'present_status1' },
      // { headerName: 'Tình trạng hiện tại lần 2', field: 'present_status2' },
      // { headerName: 'Tình trạng hiện tại lần 3', field: 'present_status3' },
      // { headerName: 'Ghi chú', field: 'note' },
      // { headerName: 'Nội dung sửa chữa', field: 'Nội dung sửa chữa' }
    ],
    listData: [],
    selectedRowKeys: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });

  const [loading, setLoading] = useState(false);
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/complaint?id_complaint=${id}`);
    if (res.data) {
      stChange({ ...stData, hotrokhieunai_show_detail: res.data }, 'detailSupportHistory');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.hotrokhieunai_show && stData.hotrokhieunai_show.id) {
      getDetail(stData.hotrokhieunai_show.id);
    }
  }, [stData.hotrokhieunai_show]);

  return (
    <Fragment>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="w-full flex items-center justify-end">

          <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
              onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}
            >
              <SettingOutlined />
            </div>

          </div>
        </div>
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.hotrokhieunai_show_detail ? [stData.hotrokhieunai_show_detail] : [], loading: loading }}
            stChange={(data = {}, type = '') => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
        </div>
      </div>
    </Fragment>
  )

}

export default TabTableDetail
